import { render, staticRenderFns } from "./lrRadio.vue?vue&type=template&id=4bd592a4"
import script from "./lrRadio.vue?vue&type=script&lang=js"
export * from "./lrRadio.vue?vue&type=script&lang=js"
import style0 from "./lrRadio.vue?vue&type=style&index=0&id=4bd592a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports